// extracted by mini-css-extract-plugin
module.exports = {"root":"EnquiryForm_root__1lpcg","icon":"EnquiryForm_icon__3QUCr","heading":"EnquiryForm_heading__2gJEv","field":"EnquiryForm_field__3D3RB","error":"EnquiryForm_error__2gcWT"};